'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useRef } from 'react';
import { Link } from '@/components/Link';
import { Swipeable } from '@/components/Swipeable';
import { Typography } from '@/components/Typography';
import { JucyLogo } from '@/components/icons/JucyLogo';
import { PhosphorIcon } from '@/components/icons/PhosphorIcon';
import type { CmsLocale, CmsSite } from '@/services/cms-sdk';
import { sitePathPrefix } from '@/services/cms-sdk/cms/utils/sitePathPrefix';
import { useTopDrawerProvider } from './TopDrawerProvider';
interface DrawerWrapperProps {
  children: ReactNode;
  cta?: ReactNode;
  id: string;
  locale?: CmsLocale;
  site?: CmsSite;
  title?: string;
  trigger: ReactNode;
}
export function DrawerWrapper(t0) {
  const $ = _c(40);
  const {
    children,
    cta,
    id,
    locale,
    site,
    title,
    trigger
  } = t0;
  const inputRef = useRef(null);
  const topDrawerRef = useTopDrawerProvider();
  let t1;
  if ($[0] !== topDrawerRef) {
    t1 = () => {
      inputRef.current?.click();
      topDrawerRef.current?.click();
    };
    $[0] = topDrawerRef;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const closeDrawerTree = t1;
  const t2 = id === "top" ? topDrawerRef : inputRef;
  let t3;
  if ($[2] !== id || $[3] !== t2) {
    t3 = <input id={id} type="checkbox" className="drawer-toggle" ref={t2} aria-label="Toggle menu" />;
    $[2] = id;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== id || $[6] !== trigger) {
    t4 = id === "top" ? <div className="drawer-content items-center !bg-none"><label htmlFor={id} className="flex flex-nowrap items-center justify-between font-semibold px-0 pt-0 gap-4">{trigger}</label></div> : null;
    $[5] = id;
    $[6] = trigger;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== closeDrawerTree) {
    t5 = {
      swipeHorizontal: closeDrawerTree
    };
    $[8] = closeDrawerTree;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      drag: "x"
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== id || $[12] !== locale || $[13] !== site || $[14] !== title) {
    t7 = id === "top" ? <Link href={sitePathPrefix({
      site,
      locale,
      absolute: true
    })} className="w-19.5" aria-label="Go to homepage"><JucyLogo width="100%" /></Link> : <><label htmlFor={id} aria-label="close sidebar" className="p-0"><PhosphorIcon className="text-[24px]" name="arrow-left" /></label><Typography as="h6" variant="h6" className="p-0">{title}</Typography></>;
    $[11] = id;
    $[12] = locale;
    $[13] = site;
    $[14] = title;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <PhosphorIcon className="text-[24px]" name="x" />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== closeDrawerTree) {
    t9 = <button onClick={closeDrawerTree} className="p-0">{t8}</button>;
    $[17] = closeDrawerTree;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <li className="bg-secondary flex flex-row justify-between items-center w-full px-6 py-4">{t7}{t9}</li>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== children) {
    t11 = <li>{children}</li>;
    $[22] = children;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = <ul tabIndex={0} className="text-white w-full m-0 p-0 !bg-transparent">{t10}{t11}</ul>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== cta || $[28] !== id) {
    t13 = id === "top" ? <div className="w-full fixed flex bottom-0 text-base-content px-6 py-8 justify-center gap-4">{cta}</div> : null;
    $[27] = cta;
    $[28] = id;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <div className="relative h-full w-full">{t12}{t13}</div>;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t14 || $[34] !== t5) {
    t15 = <Swipeable actions={t5} className="drawer-side w-full bg-white" options={t6}>{t14}</Swipeable>;
    $[33] = t14;
    $[34] = t5;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t15 || $[37] !== t3 || $[38] !== t4) {
    t16 = <div className="drawer p-0 gap-0 !bg-transparent">{t3}{t4}{t15}</div>;
    $[36] = t15;
    $[37] = t3;
    $[38] = t4;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  return t16;
}